import { render, staticRenderFns } from "./gAll.vue?vue&type=template&id=7129ad92&scoped=true&"
import script from "./gAll.vue?vue&type=script&lang=js&"
export * from "./gAll.vue?vue&type=script&lang=js&"
import style0 from "./gAll.vue?vue&type=style&index=0&id=7129ad92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129ad92",
  null
  
)

export default component.exports